import { __rest } from "tslib";
import * as React from "react";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import { Skeleton } from "@skve/components"
 *
 * function Demo() {
 *   return (
 *     <div className="flex items-center space-x-4">
 *       <Skeleton className="h-12 w-12 rounded-full" />
 *       <div className="space-y-2">
 *         <Skeleton className="h-4 w-[250px]" />
 *         <Skeleton className="h-4 w-[200px]" />
 *       </div>
 *     </div>
 *   )
 * }
 * ```
 */
const Skeleton = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ className: cn("animate-pulse rounded-md bg-muted", className) }, props)));
};
export { Skeleton };
//# sourceMappingURL=skeleton.js.map